import {
  SET_CONSENT_PROPS
} from '../const/action_types.js';

export default (state = {}, action)=> {

  switch (action.type) {

  case SET_CONSENT_PROPS:
  
    return {
      ...state,
      ...action.consentProps
    };

  default: {
    return state;
  }

  }
};

export const getConsentProps = (state)=> state;
